<template>
  <div>
    <div class="R">
      <el-row
        style="position: absolute;width:100%;background-color: #fff;z-index: 1;box-sizing: border-box;font-size: 12px;"
      >
        <el-col :span="5">
          <el-input
            v-model="keyword"
            size="mini"
            clearable
            style="width:100px;margin-left: 10px;"
            @keyup.enter.native="clickSearch"
            placeholder="请输入"
          ></el-input>
          <el-button size="mini" type="warning" @click="clickSearch">搜索</el-button>
        </el-col>
        <el-col :span="7">
          价格区间
          <span class="price">
            <el-input
              v-model="minPrice"
              size="mini"
              style="width:50px;margin-right: 4px;"
              @input="changeMinPrice"
            ></el-input>-
            <el-input
              v-model="maxPrice"
              size="mini"
              style="width:50px;margin-right: 6px;"
              @input="changeMaxPrice"
            ></el-input>
            <el-button size="mini" type="warning" @click="clickSearchPrice">搜索</el-button>
          </span>
        </el-col>
        <el-col :span="6">
          门店
          <el-select
            v-model="shop"
            @change="changeShop"
            placeholder="请选择"
            size="mini"
            clearable
            style="width:100px"
          >
            <el-option
              v-for="(item,indexShop) in shopList"
              :key="indexShop"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          活动促销
          <el-select
            v-model="hasActivity"
            @change="changeHasActivity"
            placeholder="请选择"
            size="mini"
            clearable
            style="width:75px"
          >
            <el-option
              v-for="(item,indexActivity) in [{label:'不限',value:-1},{label:'是',value:1},{label:'否',value:2}]"
              :key="indexActivity"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <el-row>
      <el-table :data="tableData">
      <el-table-column property="price" label="价格"></el-table-column>
      <el-table-column property="product.pet_age" label="年龄"></el-table-column>
      <el-table-column property="product.inside_name" label="名称">
        <template slot-scope="scope">
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              <img :src="scope.row.product.cover" style="width:120px;height: 120px;" />
            </div>
            <div>{{scope.row.product.inside_name}}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column property="product.inside_no" label="芯片"></el-table-column>
      <el-table-column property="product.eprom_no" label="编号"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="changePet(scope.row)" type="warning" size="small">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    </el-row>
    <div class="pageLine">
      <page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
    </div>
  </div>
</template>

<script>
import page from "../../../../components/page.vue"
export default {
  components: { page },
  data () {
    return {
      // 筛选
      keyword: '',
      minPrice: '',
      maxPrice: '',
      curCascader: [],
      shop: '',
      hasActivity: -1,
      petClass: '0',
      petSex: '0',
      petType: [''],
      petColor: ['全部'],
      petFeatures: ['全部'],
      petNeedleNumber: ['全部'],
      petAge: ['0,0'],
      addDay: 0,
      // 活体列表
      tableData: [],
      page: {
        page: 1,
        pageSize: 5,
        total: 0
      },
      drawerLivingScreen_state: false,
    }
  },
  created () {
    this.getList();
  },
  computed: {
    userInfo () {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {}
        }
      }
    },
    curPetId () {
      return this.$store.state.mendian.curPetId;
    },
    curPetInfo () {
      return this.$store.getters['mendian/curPetInfo'];
    },
    shopList () {
      return this.$store.getters['shopList']
    },
    addParams () {
      return this.$store.state.living.addParams;
    },
    money () {
      return this.$store.state.living.money;
    },
    activityMoney () {
      return this.$store.state.living.activityMoney;
    },
    curDiscountCard () {
      return this.$store.state.living.curDiscountCard;
    },
    refresh () {
      return this.$store.state.living.refresh;
    },
  },
  methods: {
    // 选择退换宠物
    changePet (row) {
      //   console.log(row);
      this.$emit('submit', row)
    },
    // 关键字
    clickSearch () {
      this.page.page = 1;
      this.getList();
    },
    // 价格区间
    changeMinPrice () {
      this.minPrice = this.$public.replaceGoodsDosage(this.minPrice)
    },
    changeMaxPrice () {
      this.maxPrice = this.$public.replaceGoodsDosage(this.maxPrice)
    },
    clickSearchPrice () {
      this.page.page = 1;
      this.getList();
    },
    changeShop () {
      this.page.page = 1;
      this.getList();
    },
    changeHasActivity () {
      this.page.page = 1;
      this.getList();
    },
    changeItem (row) {
      if (row.product.sale_status && row.product.sale_status.value === '2') {
        this.$message({
          message: '该宠物已被预定',
          type: 'error'
        });
        return;
      }
      this.activityId = '';
      this.activityList = row.activity_list;
      this.curItem = row;
      this.addParams.curItem = this.curItem;
      this.$store.commit('living/set_addParams', this.addParams)
      this.$store.commit('living/set_money', row.price)
      this.$store.commit('living/set_activityMoney', row.price)
      this.$store.commit('living/set_curDiscountCard', null)
    },
    changePage (num) {
      this.page.page = num;
      this.getList()
    },
    getList () {
      if (!this.$public.isNull(this.minPrice) && this.$public.isNull(this.maxPrice)) {
        this.$message({
          message: '区间最大值输入有误！',
          type: 'error'
        });
        return;
      }
      if (!this.$public.isNull(this.maxPrice) && this.$public.isNull(this.minPrice)) {
        this.$message({
          message: '区间最小值输入有误',
          type: 'error'
        });
        return;
      }
      let petClass = [];
      if (this.petClass === '0') {
        petClass = []
      } else if (this.petClass === '1') {
        petClass = ['1']
      } else if (this.petClass === '2') {
        petClass = ['2']
      }
      let petSex = [];
      if (this.petSex === '0') {
        petSex = []
      } else if (this.petSex === '1') {
        petSex = ['公']
      } else if (this.petSex === '2') {
        petSex = ['母']
      }
      let min_month = 10000;
      let max_month = 0;
      for (let i = 0; i < this.petAge.length; i++) {
        let month = this.petAge[i].split(',')
        if (min_month > month[0]) {
          min_month = month[0]
        }
        if (max_month < month[1]) {
          max_month = month[1]
        }
      }
      let add_day = this.addDay
      let params = {
        category: this.petType[0] === '' ? [] : this.petType,
        min_month: Number(min_month),
        max_month: Number(max_month),
        vaccine_complete_count: this.petNeedleNumber[0] === '全部' ? [] : this.petNeedleNumber, // 完成计划数量
        apply_type: petClass, // 1:猫 2:犬
        pet_state: ['1', '2'], // 1 可出售 2 锁定
        pet_sex: petSex, // 宠物的性别 公 母
        custom_features: this.petFeatures[0] === '全部' ? [] : this.petFeatures, // 宠物特征
        pet_color: this.petColor[0] === '全部' ? [] : this.petColor, // 宠物颜色
        order_type: -1, // 排序类型 -1 上架时间 1 价格 2 月份
        order_asc: 2, // 正序倒叙 1 正序 2 倒叙

        "page_index": this.page.page,
        "page_size": this.page.pageSize,
        "keyword": this.keyword,
        "shop_id": this.shop,
        // "unified_category_id": this.curCascader.length===2?this.curCascader[1]:'',  // 品种id
        "is_activity": this.$public.isNull(this.hasActivity) ? -1 : this.hasActivity,  // -1 不限 1 参与活动 2 不参与活动
        pet_level: this.level,// 宠物星级
        min_price: this.minPrice ? Number(this.minPrice) : 0,
        max_price: this.maxPrice ? Number(this.maxPrice) : 0,
        add_day: add_day,
      }
      let loading = this.$loading();
      this.$http.post(process.env.VUE_APP_Url6 + 'api/Activity/GetPetRelevanceList', params).then(res => {
        loading.close();
        console.log(res);
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.page.total = res.data.count;
        }
      })
    },
    // 活动
    changeActivityId () {
      this.addParams.activityId = this.activityId
      this.addParams.activityItem = this.$public.getMatchingItem(this.activityList, "_id", this.activityId)
      this.$store.commit('living/set_addParams', this.addParams)
      if (this.$public.isNull(this.addParams.activityId)) {
        this.giveGoods = {}
        this.$store.commit('living/set_activityMoney', this.money)
      } else {
        let calcResult = this.$public.calcActivity(this.addParams.activityItem, this.money, 1)
        this.$store.commit('living/set_activityMoney', calcResult.newPrice)
        if (!this.$public.isNull(calcResult.gift.give_list)) {
          this.giveGoods = calcResult.gift;
          this.drawerGift_state = true;
        }
      }
    },
  }
}
</script>

<style lang = "scss" scoped>
.R {
  width: 100%;
  height:50px;
  position: relative;
  padding-top: 10px;
  &::-webkit-scrollbar {
    width: 4px;
    // height: 4px;
  }
  .price {
    ::v-deep .el-input__inner {
      padding: 0 5px;
    }
  }
  .screenBtn {
    width: 60px;
    height: 28px;
    border-radius: 2px;
    text-align: center;
    line-height: 28px;
    color: #999;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }
  .list {
    margin: 0 12px;
    padding: 40px 0 60px;
    height: 100%;
    box-sizing: border-box;
    overflow: auto;
    .item {
      display: inline-block;
      width: 174px;
      height: 320px;
      border-radius: 4px;
      overflow: hidden;
      border: 2px solid rgba(151, 151, 151, 0.25);
      position: relative;
      margin: 0px 6px 6px;
      cursor: pointer;
      box-sizing: border-box;
      &.active {
        border-color: $mainColor;
        background-color: rgba(245, 136, 42, 0.06);
      }

      .price {
        font-size: 18px;
        color: #ff4646;
      }
    }
  }
}
</style>